<template>
  <div class="customersFeedback">
    <Loading v-if="loading" />
    <div class="customersFeedback__container">
      <Title :title="$t('customersFeedback')" />
      <img
        v-if="pharmacy?.remomediServices.feedback_tablet"
        class="customersFeedback__settings"
        src="@/assets/icons/Settings.svg"
        alt="Settings"
        @click="goToSettings"
      />
    </div>
    <Tabs :tabs="tabs" @select-tab="setActiveTab" />
    <router-view :pharmacy="pharmacy"></router-view>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import router from '@/router';

import { tabs } from './configs';

@Options({
  name: 'CustomersFeedback',
  components: {
    Loading
  },
  data() {
    return {
      pharmacyId: '',
      loading: false,
      tabs
    };
  },
  created() {
    if (this.user) {
      this.pharmacyId = this.user?.pharmacyId;

      this.show();
    }
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapState('pharmacy', ['pharmacy'])
  },
  methods: {
    ...mapActions('pharmacy', ['getPharmacy']),
    async show() {
      this.loading = true;

      await this.getPharmacy(this.pharmacyId);

      this.setActiveTab('CustomersSatisfactionReport');

      this.loading = false;
    },
    async setActiveTab(tabValue: string) {
      router.push({ name: tabValue });
    },
    goToSettings() {
      router.push({ name: 'SettingsCustomersFeedback' });
    }
  }
})
export default class CustomersFeedback extends Vue {}
</script>

<style lang="scss" scoped>
.customersFeedback {
  .customersFeedback__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 24px;
    .customersFeedback__settings {
      cursor: pointer;
    }
  }
}
</style>
